import { useTranslation } from 'react-i18next'
import React, { useEffect, useState } from 'react'

import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import styles from './TaskCoWorker.module.scss'

function TaskCoWorker({ dataCoWorker, setCoWorker }) {
  const { t } = useTranslation('common')


  const [isLoading, setIsLoading] = useState(true)
  const animatedComponents = makeAnimated()

  const handleSelect = (dataCoWorker) => {
    setCoWorker(dataCoWorker)
  }
  useEffect(() => {
    if (dataCoWorker[0]?.length !== 0) {
      setIsLoading(false)
    }
  }, [dataCoWorker])

  return (
    <div className={styles.inline}>
      <div className={styles.task_responsible}>
        <p>{t('auto.taskcoworker_taskcoworker.k1')}</p>

        <Select
          closeMenuOnSelect={true}
          components={animatedComponents}
          isMulti
          options={dataCoWorker[0]}
          onChange={handleSelect}
          isSearchable={true}
          placeholder={t('auto.taskcoworker_taskcoworker.k2')}
          autosize={true}
          noOptionsMessage={() => 'Поиск не дал результатов'}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}

export default React.memo(TaskCoWorker)
